(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-quad"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('banner-quad-rotator')) {
  class BannerQuadRotator extends HTMLElement {
    connectedCallback() {
      this._setupGen = 0;
      this.setup();
      this._observer = new MutationObserver(() => this.setup());
      this._observer.observe(this, { attributes: true, attributeFilter: ['data-layout'] });
    }

    disconnectedCallback() {
      this.teardown();
      if (this._observer) this._observer.disconnect();
    }

    get index() {
      return this.swiper ? this.swiper.activeIndex : 0;
    }

    slides() {
      if (!this.track) return [];
      return Array.from(this.track.children).filter((el) => el.querySelector('.banner-quad__item'));
    }

    setup() {
      this.teardown();
      this.viewport = this.querySelector('.banner-quad__viewport');
      this.track = this.querySelector('[data-banner-quad-track]');
      this.controls = this.querySelector('[data-banner-quad-controls]');
      this.dotsEl = this.querySelector('[data-banner-quad-dots]');
      this.prevBtn = this.querySelector('[data-banner-quad-prev]');
      this.nextBtn = this.querySelector('[data-banner-quad-next]');
      const layout = this.getAttribute('data-layout');
      const items = this.slides();
      const canCarousel = layout === 'carousel' && items.length > 1;

      if (!canCarousel) {
        this.removeAttribute('data-ready');
        if (this.controls) this.controls.hidden = true;
        return;
      }

      items.forEach((el) => {
        el.draggable = false;
        el.classList.add('swiper-slide');
        el.querySelectorAll('a, img').forEach((node) => {
          node.draggable = false;
        });
      });
      if (this.viewport) this.viewport.classList.add('swiper');
      this.track.classList.add('swiper-wrapper');

      const gen = ++this._setupGen;
      const start = () => {
        if (gen !== this._setupGen || !this.isConnected) return;
        this.initSwiper();
      };
      const loadSwiper = () => {
        if (typeof window.ensureThemeSwiper === 'function') return window.ensureThemeSwiper();
        if (typeof window.Swiper === 'function') return Promise.resolve(window.Swiper);
        return new Promise((resolve, reject) => {
          let tries = 0;
          const timer = window.setInterval(() => {
            tries += 1;
            if (typeof window.ensureThemeSwiper === 'function') {
              window.clearInterval(timer);
              window.ensureThemeSwiper().then(resolve).catch(reject);
            } else if (typeof window.Swiper === 'function') {
              window.clearInterval(timer);
              resolve(window.Swiper);
            } else if (tries > 40) {
              window.clearInterval(timer);
              reject();
            }
          }, 50);
        });
      };
      loadSwiper().then(start).catch(() => {});
    }

    initSwiper() {
      if (!this.viewport || typeof window.Swiper !== 'function') return;
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplayOn = this.getAttribute('data-autoplay') === 'true' && !reduceMotion;
      const delay = parseInt(this.getAttribute('data-interval') || '3000', 10);

      this.swiper = new window.Swiper(this.viewport, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 400,
        rewind: true,
        grabCursor: true,
        simulateTouch: true,
        allowTouchMove: true,
        followFinger: true,
        threshold: 8,
        longSwipesRatio: 0.3,
        resistanceRatio: 0.65,
        touchStartPreventDefault: false,
        preventClicks: true,
        preventClicksPropagation: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },
        pagination: {
          el: this.dotsEl,
          clickable: true,
          bulletClass: 'banner-quad__dot',
          bulletActiveClass: 'is-active',
          renderBullet: function (index, className) {
            return (
              '<button type="button" class="' +
              className +
              '" aria-label="Banner ' +
              (index + 1) +
              '"></button>'
            );
          },
        },
        autoplay: autoplayOn
          ? {
              delay: delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        a11y: {
          slideRole: '',
        },
        on: {
          sliderFirstMove: (swiper) => {
            if (autoplayOn && swiper.autoplay) swiper.autoplay.stop();
          },
          touchEnd: (swiper) => {
            if (autoplayOn && swiper.autoplay) swiper.autoplay.start();
          },
          slideChangeTransitionEnd: (swiper) => {
            if (autoplayOn && swiper.autoplay) {
              swiper.autoplay.stop();
              swiper.autoplay.start();
            }
          },
        },
      });

      if (this.controls) this.controls.hidden = false;
      this.setAttribute('data-ready', 'true');
    }

    teardown() {
      this._setupGen += 1;
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      if (this.viewport) this.viewport.classList.remove('swiper');
      if (this.track) {
        this.track.classList.remove('swiper-wrapper');
        Array.from(this.track.children).forEach((el) => el.classList.remove('swiper-slide'));
      }
      if (this.dotsEl) this.dotsEl.innerHTML = '';
      this.removeAttribute('data-ready');
    }

    pause() {
      if (this.swiper && this.swiper.autoplay) this.swiper.autoplay.stop();
    }

    go(nextIndex, smooth) {
      if (!this.swiper) return;
      this.swiper.slideTo(nextIndex, smooth === false ? 0 : 400);
    }
  }

  customElements.define('banner-quad-rotator', BannerQuadRotator);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('collection-faq')) {
  class CollectionFaq extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('details.collection-faq__item').forEach((item) => {
        if (item.dataset.faqReady) return;
        item.dataset.faqReady = 'true';

        const body = item.querySelector('.collection-faq__body');
        const summary = item.querySelector('summary');
        if (!body || !summary) return;

        const inner = body.firstElementChild;
        let expanded = item.open;
        let animating = false;

        const finish = (open) => {
          animating = false;
          expanded = open;
          body.style.height = open ? 'auto' : '0px';
          if (open) {
            item.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');
          } else {
            item.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
        };

        const expand = () => {
          animating = true;
          item.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
          body.style.height = '0px';
          body.offsetHeight;
          body.style.height = `${inner.scrollHeight}px`;
        };

        const collapse = () => {
          animating = true;
          item.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'false');
          body.style.transition = 'none';
          body.style.height = `${inner.scrollHeight}px`;
          body.offsetHeight;
          body.style.transition = '';
          requestAnimationFrame(() => {
            body.style.height = '0px';
          });
        };

        body.style.transition = 'none';
        body.style.height = expanded ? 'auto' : '0px';
        body.offsetHeight;
        body.style.transition = '';
        summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (expanded) item.setAttribute('open', '');

        body.addEventListener('transitionend', (event) => {
          if (event.propertyName !== 'height' || !animating) return;
          finish(summary.getAttribute('aria-expanded') === 'true');
        });

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (animating) return;
          if (expanded) collapse();
          else expand();
        });
      });
    }
  }

  customElements.define('collection-faq', CollectionFaq);
}

function firstCarType(types) {
  const raw = String(types || '').split(',')[0].trim();
  if (!raw) return '';
  const low = raw.toLowerCase();
  if (low.includes('suv')) return 'SUV';
  if (low.includes('kombi')) return 'kombi';
  if (low.includes('sedan')) return 'sedan';
  if (low.includes('hatch')) return 'hatchback';
  if (low.includes('mpv') || low.includes('van')) return 'MPV';
  return raw;
}

function fuelKind(fuels) {
  const s = String(fuels || '').toLowerCase();
  const ev = s.includes('elekt');
  const hyb = s.includes('hybrid');
  const die = s.includes('naft');
  const pet = s.includes('benz') || s.includes('natural');
  if (ev && !die && !pet) return 'ev';
  if (hyb && !die && !pet && !ev) return 'hybrid';
  if (die && pet) return 'both';
  if (die) return 'diesel';
  if (pet) return 'petrol';
  if (hyb) return 'hybrid';
  if (ev) return 'ev';
  return '';
}

function modelCompareSentence(name, spec) {
  const kind = fuelKind(spec.fuels);
  const type = firstCarType(spec.types);
  let head = '';
  if (kind === 'ev') head = type === 'SUV' ? 'elektrické SUV' : 'elektromobil';
  else if (kind === 'hybrid') head = type ? `hybridní ${type}` : 'hybrid';
  else if (kind === 'both') head = type ? `${type} na benzín i naftu` : 'vůz na benzín i naftu';
  else if (kind === 'diesel') head = type ? `${type} na naftu` : 'vůz na naftu';
  else if (kind === 'petrol') head = type ? `${type} na benzín` : 'vůz na benzín';
  else if (type) head = type;

  const battery = parseInt(spec.battery, 10) || 0;
  const range = parseInt(spec.range, 10) || 0;
  let extras = '';
  if (kind === 'ev' && battery > 0 && range > 0) extras = ` s baterií ${battery} kWh a dojezdem až ${range} km`;
  else if (kind === 'ev' && range > 0) extras = ` s dojezdem až ${range} km`;
  else if (kind === 'ev' && battery > 0) extras = ` s baterií ${battery} kWh`;

  const awd = spec.awd ? ', v nabídce i s pohonem 4x4' : '';
  const price = String(spec.price || '').trim();
  let sentence = name;
  if (head) sentence += ` je ${head}${extras}${awd}`;
  else if (extras || awd) sentence += extras + awd;
  if (price) sentence += `${head || extras || awd ? ' a začíná na ' : ' začíná na '}${price} Kč měsíčně bez DPH`;
  return `${sentence}.`;
}

function fillFaqAltPrice(models) {
  document.querySelectorAll('collection-faq[data-alt-model]').forEach((faq) => {
    const alt = (faq.getAttribute('data-alt-model') || '').toLowerCase();
    if (!alt) return;
    const match = (models || []).find((model) => String(model.name || '').toLowerCase() === alt);
    const slot = faq.querySelector('[data-faq-alt-price]');
    const wrap = faq.querySelector('[data-faq-alt-price-wrap]');
    const price = match && match.price_text ? String(match.price_text).trim() : '';
    if (slot && price) {
      slot.textContent = price;
      if (wrap) wrap.hidden = false;
    }

    const diffItem = faq.querySelector('[data-faq-models-diff]');
    const diff = diffItem && (diffItem.querySelector('.collection-faq__answer p') || diffItem.querySelector('.collection-faq__answer'));
    if (!diff || !match) return;
    const current = {
      fuels: faq.getAttribute('data-faq-fuels') || '',
      types: faq.getAttribute('data-faq-types') || '',
      awd: faq.getAttribute('data-faq-awd') === '1',
      range: faq.getAttribute('data-faq-range') || '',
      battery: faq.getAttribute('data-faq-battery') || '',
      price: faq.getAttribute('data-faq-price') || '',
    };
    const other = {
      fuels: match.fuels || '',
      types: match.types || '',
      awd: !!match.awd,
      range: match.range || '',
      battery: match.battery || '',
      price: match.price_text || price,
    };
    const currentName = faq.getAttribute('data-faq-model') || '';
    const altName = faq.getAttribute('data-alt-model') || '';
    if (!currentName || !altName) return;
    diff.textContent = `${modelCompareSentence(currentName, current)} ${modelCompareSentence(altName, other)}`;
  });
}

function mergeFaqModels(rows) {
  const order = [];
  const map = {};
  (rows || []).forEach((row) => {
    ((row && row.models) || []).forEach((model) => {
      if (!model || !model.id) return;
      if (!map[model.id]) {
        map[model.id] = Object.assign({}, model);
        order.push(model.id);
        return;
      }
      const current = map[model.id];
      current.count = (current.count || 0) + (model.count || 0);
      if (model.price != null && (current.price == null || model.price < current.price)) {
        current.price = model.price;
        current.price_text = model.price_text;
      }
      if (model.awd) current.awd = true;
      if (model.range && (!current.range || model.range > current.range)) current.range = model.range;
      if (model.battery && (!current.battery || model.battery > current.battery)) current.battery = model.battery;
    });
  });
  return order.map((id) => map[id]);
}

function loadFaqAltModels() {
  if (!document.querySelector('collection-faq[data-alt-model]')) return;
  const next = new URLSearchParams();
  new URLSearchParams(window.location.search).forEach((val, key) => {
    if (key === 'page' || key === 'section_id' || key === 'view' || key.indexOf('car_model') !== -1) return;
    next.append(key, val);
  });
  next.set('view', 'brand-models');
  next.set('page', '1');
  const path = window.location.pathname;
  fetch(`${path}?${next.toString()}`, { credentials: 'same-origin' })
    .then((r) => r.json())
    .then((first) => {
      const pages = Math.max(1, Number(first && first.pages) || 1);
      const jobs = [Promise.resolve(first)];
      for (let p = 2; p <= pages; p += 1) {
        next.set('page', String(p));
        jobs.push(
          fetch(`${path}?${next.toString()}`, { credentials: 'same-origin' })
            .then((r) => r.json())
            .catch(() => null),
        );
      }
      return Promise.all(jobs);
    })
    .then((rows) => {
      fillFaqAltPrice(mergeFaqModels(rows));
    })
    .catch(() => {});
}

document.addEventListener('related-models:ready', (event) => {
  fillFaqAltPrice(event.detail && event.detail.models);
});
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadFaqAltModels);
} else {
  loadFaqAltModels();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
